import { useEffect } from "react";
import { useShallow } from "zustand/react/shallow";

import useAssistantPanelStore from "../useStore";
import { RESPONSIVE_BREAKPOINT } from "../constants";

const useAssistantPanelResponsiveVariant = () => {
  const { initializeAssistantPanel, onScreenBreakpointChange, clampFloatingToViewport } =
    useAssistantPanelStore(
      useShallow((state) => ({
        initializeAssistantPanel: state.initialize,
        onScreenBreakpointChange: state.onScreenBreakpointChange,
        clampFloatingToViewport: state.clampFloatingToViewport,
      }))
    );

  useEffect(() => {
    const mediaQuery = window.matchMedia(`(max-width: ${RESPONSIVE_BREAKPOINT}px)`);

    initializeAssistantPanel(mediaQuery.matches);

    const handleMediaChange = (event: MediaQueryListEvent) => {
      onScreenBreakpointChange(event.matches);
    };

    mediaQuery.addEventListener("change", handleMediaChange);

    return () => {
      mediaQuery.removeEventListener("change", handleMediaChange);
    };
  }, [initializeAssistantPanel, onScreenBreakpointChange]);

  useEffect(() => {
    clampFloatingToViewport();

    window.addEventListener("resize", clampFloatingToViewport);

    return () => {
      window.removeEventListener("resize", clampFloatingToViewport);
    };
  }, [clampFloatingToViewport]);
};

export default useAssistantPanelResponsiveVariant;
